import React, { Component } from 'react';
import { Form, Icon, Input, Button } from 'antd';
import './css/style.css';
import logo from './img/logo.png';
import {IndexContainer, BoxContainer} from '../pages/styled-components/index';
const FormItem = Form.Item;

class Homepage extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values);
          }
        });
      }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <IndexContainer>
                <BoxContainer>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <div style={{display:'flex', justifyContent:'center' }} >
                            <img src={logo} alt="logo" />
                        </div>
                        <FormItem>
                            {getFieldDecorator('userName', {
                                rules: [{ required: true, message: 'Please input your username!' }],
                            })(
                                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                            )}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: 'Please input your Password!' }],
                            })(
                                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                            )}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" style={{width:'100%'}} className="login-form-button">
                                Log in
                            </Button>
                        </FormItem>
                    </Form>
                </BoxContainer>
            </IndexContainer>
    );
  }
}
  export default Form.create()(Homepage);

  


// WEBPACK FOOTER //
// ./src/components/pages/index.js